import { Spinner } from '@/components/Spinner';
import { useAsyncData } from '@/hooks/useAsyncData';
import { formatDateTime } from '@/lib/clientFormat';
import { fetchClientHistory } from '@/api/clients';

/**
 * Отдельный запрос при каждом открытии вкладки (не срез из fetchClient) —
 * иначе история не увидела бы собственные же изменения на других вкладках
 * (тест/цена/баланс) без полной перезагрузки страницы.
 */
export function HistoryPanel({ accountId }: { accountId: number }) {
  const { data: entries, error } = useAsyncData(
    () => fetchClientHistory(accountId),
    [accountId],
    'Не удалось загрузить историю изменений.',
  );

  if (error) return <p className="field-error">{error}</p>;
  if (entries === null) {
    return (
      <div className="panel-loading">
        <Spinner />
      </div>
    );
  }
  if (entries.length === 0) return <p className="cell-muted">Изменений пока не было.</p>;

  return (
    <div className="timeline">
      {entries.map((entry, i) => (
        <div className="timeline__item" key={`${entry.date ?? ''}-${i}`}>
          <div className="timeline__rail">
            <div className="timeline__dot" />
            <div className="timeline__line" />
          </div>
          <div className="timeline__content">
            <div className="timeline__text">{entry.action}</div>
            <div className="timeline__meta">
              {formatDateTime(entry.date)}
              {entry.author && ` · ${entry.author}`}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
